import { render, staticRenderFns } from "./MainFund.vue?vue&type=template&id=a21f091a&"
import script from "./MainFund.vue?vue&type=script&lang=js&"
export * from "./MainFund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports